<template>
  <div class="share-setting-box" v-loading="loading > 0">
    <Header :title="pageTitle"></Header>
    <div class="container">
      <div class="content">
        <div class="title">奶粉知道文章</div>
        <el-form
          label-width="110px"
          label-position="right"
          :rules="rules"
          ref="form"
          class="configure-form"
        >
          <el-form-item label="标题" prop="articleTitle" class="form-item">
            <el-input
              placeholder="请输入标题"
              class="input"
              v-model="form.articleTitle"
              style="width: 400px"
            ></el-input>
          </el-form-item>
          <el-form-item class="img_item" prop="articlePic" label="文章主图">
          <div class="addImg">
            <p class="tips">建议尺寸：416*260，图片类型jpg、png</p>
            <div class="img-box">
              <img
                ref="img"
                :src="form.articlePic"
                v-if="form.articlePic"
              />
              <div class="icon" v-else>
                <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                <p>图片</p>
                <p class="tip">支持扩展名：.jpg .png</p>
              </div>
              <input
                type="file"
                class="file"
                ref="inputImg"
                accept="image/png, image/jpg, image/jpeg"
                @change="addChangeImg"
              />
            </div>
          </div>
        </el-form-item>
          <el-form-item label="所属分类" prop="classifyId" class="form-item">
            <el-select
              v-model="form.classifyId"
              placeholder="请选择分类"
              style="width: 270px"
              class="input"
            >
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.classifyName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联产品" prop="slogan" class="form-item">
            <div class="add-goods-box">
              <div class="left">
                <!-- <div class="item" v-for="(item, index) in goodsList" :key="item.id">
                {{ item.id }}
                <span v-if="index !== goodsList.length - 1">、</span>
                </div> -->
                <div class="item" v-for="(item, index) in selectedGoods" :key="index">
                  {{ item.name }}
                  <div class="iconfont icon-shanchu" @click="deleteGoodSelected(index)"></div>
                </div>
              </div>
              <div class="btn" @click="addGoodsModal">+ 添加关联产品</div>
            </div>
          </el-form-item>
          <el-form-item label="关联品牌" prop="slogan" class="form-item">
            <div class="add-goods-box">
              <div class="left">
                <!-- <div class="item" v-for="(item, index) in selectedBrand" :key="item.id">
                {{ item.id }}
                <span v-if="index !== selectedBrand.length - 1">、</span>
                </div> -->
                <div class="item" v-for="(item, index) in selectedBrand" :key="index">
                  {{ item.brandName }}
                  <div class="iconfont icon-shanchu" @click="deleteBrandSelected(index)"></div>
                </div>
              </div>
              <div class="btn" @click="addBrandModal">+ 添加关联品牌</div>
            </div>
          </el-form-item>
          <el-form-item label="文章内容" prop="slogan" class="form-item">
            <WangEditor
              :text="form.content"
              class="text"
              @change="changeText"
            />
          </el-form-item>
        </el-form>
        <!-- <div class="btn-box">
            <button class="btn" @click="handleShare">保存设置</button>
          </div> -->
      </div>
      <div class="btn-box">
        <!-- <button class="cancel-btn" @click="handleCancel">取消</button> -->
        <button class="confirm-btn" @click="handleConfirm">保存设置</button>
      </div>
    </div>
    <el-dialog title="添加产品ID" width="620px" :visible.sync="addGoodsVisible">
      <div class="add-goods-dialog">
        <div class="search-box">
          输入产品ID：
          <el-input
            placeholder="请输入标题"
            class="input"
            size="small"
            @input="goodsTip = false"
            v-model="goodId"
            style="width: 240px"
          ></el-input>
          <div class="btn" @click="getGoodInfoById">
            查询
          </div>
        </div>
        <div class="tip" v-if="goodsTip">
          未查询到该ID的产品，请检查ID是否有效后重新查询
        </div>
        <el-table
          :data="goodsList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="masterPic"
            align="center"
            label="产品图"
          >
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.masterPic"
                :preview-src-list="[scope.row.masterPic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="产品ID"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <div slot-scope="scope" style="display: flex;justify-content: center;">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteGood(scope.$index)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addGoodsVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addGoods">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加品牌ID" width="620px" :visible.sync="addBrandVisible">
      <div class="add-goods-dialog">
        <div class="search-box">
          输入品牌ID：
          <el-input
            placeholder="请输入标题"
            class="input"
            size="small"
            v-model="brandId"
            @input="brandTip = false"
            style="width: 240px"
          ></el-input>
          <div class="btn" @click="getBrandInfoById">
            查询
          </div>
        </div>
        <div class="tip" v-if="brandTip">
          未查询到该ID的品牌，请检查ID是否有效后重新查询
        </div>
        <el-table
          :data="brandList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="logo"
            align="center"
            label="logo"
          >
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="品牌ID"
          ></el-table-column>
          <el-table-column
            prop="brandName"
            align="center"
            label="品牌名称"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <div slot-scope="scope" style="display: flex;justify-content: center;">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBrand(scope.$index)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addBrandVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import WangEditor from '../../components/common/wang-edit';
export default {
  components: {
    Header,
    WangEditor
  },
  name: 'share-setting',
  data() {
    return {
      pageTitle: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '奶粉知道文章详情'
      },
      loading: 0,
      form: {
        articleType: 3,
        way: 1,
        articlePic: '',
        articleTitle: '',
        classifyId: null,
        linkProductId: [],
        linkBrandId: [],
        content: ''
      },
      rules: {},
      categoryList: [],
      id: null,
      articleType: 3,
      classifyType: 3,
      addGoodsVisible: false,
      goodsList: [],
      selectedGoods: [],
      selectedGoodsPre: [],
      goodId: null,
      addBrandVisible: false,
      brandList: [],
      selectedBrand: [],
      selectedBrandPre: [],
      brandId: null,
      goodsTip: false,
      brandTip: false,
    };
  },
  async mounted() {
    this.getPlatformCategoryList();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = +query.id;
      this.getInfo();
    }
  },
  computed: {},
  methods: {
    // 获取分享详情
    getInfo() {
      this.loading++;
      return this.httpGet(this.$root.getPlatformArticleInfo, {
        id: this.id
      }).then(
        (res) => {
          this.loading--;
          let form = { ...this.form };
          for (let key in form) {
            form[key] = res[key];
          };
          this.form = form;
          this.selectedBrand = res.linkBrand.map(item => {return {...item, brandName: item.name}});
          this.selectedGoods = res.linkProduct;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPlatformCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getPlatformCategoryList, {
        classifyType: this.classifyType
      }).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getGoodInfoById(){
      let filterArr = this.goodsList.filter(item => item.id === +this.goodId);
      if(filterArr && filterArr.length){
        this.$message.warning('该产品已存在，请重新选择！')
        return;
      }
      this.loading++;
      this.httpGet(this.$root.getProductInfo, {
        id: this.goodId
      }).then(
        (res) => {
          this.loading--;
          if(!res.id){
            this.goodsTip = true;
            return;
          };
          this.goodsTip = false;
          this.goodsList = [...this.goodsList, res];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addGoodsModal(){
      this.goodsList = [];
      this.goodId = null;
      // this.goodsList = this.selectedGoods;
      this.addGoodsVisible = true;
    },
    deleteGoodSelected(index){
      this.selectedGoods.splice(index, 1);
    },
    deleteGood(index){
      this.goodsList.splice(index, 1);
    },
    addGoods(){
      // this.selectedGoods = this.goodsList;
      let list = [...this.selectedGoods, ...this.goodsList];
      this.selectedGoods = Array.from(
        new Map(list.map(item => [item.id, item])).values()
      );
      this.addGoodsVisible = false;
    },
    getBrandInfoById(){
      let filterArr = this.brandList.filter(item => item.id === +this.brandId);
      if(filterArr && filterArr.length){
        this.$message.warning('该品牌已存在，请重新选择！')
        return;
      }
      this.loading++;
      this.httpGet(this.$root.getBrandInfo, {
        id: this.brandId
      }).then(
        (res) => {
          this.loading--;
          if(!res.id){
            this.brandTip = true;
            return;
          };
          this.brandTip = false;
          this.brandList = [...this.brandList, res];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addBrandModal(){
      this.brandList = [];
      this.brandId = null;
      // this.brandList = this.selectedBrand;
      this.addBrandVisible = true;
    },
    deleteBrand(index){
      this.brandList.splice(index, 1);
    },
    deleteBrandSelected(index){
      this.selectedBrand.splice(index, 1);
    },
    addBrand(){
      // this.selectedBrand = this.brandList;
      let list = [...this.selectedBrand, ...this.brandList];
      this.selectedBrand = Array.from(
        new Map(list.map(item => [item.id, item])).values()
      );
      this.addBrandVisible = false;
    },
    changeText(val) {
        // 文本更改
        this.form.content = val;
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.form, 'articlePic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['articlePic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    // 保存修改
    handleConfirm(){
      this.loading++;
      let method = 'httpPost';
      let inputData = {
        ...this.form,
        linkProductId: this.selectedGoods.map(item => item.id),
        linkBrandId: this.selectedBrand.map(item => item.id)
      };
      if (this.id) {
        method = 'httpPut';
        inputData.id = this.id;
      }
      this[method](
        this.id ? this.$root.updatePlatformArticle : this.$root.addPlatformArticle, // 添加商品 or 创建商品
        inputData,
      ).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          // this.getInfo();
          this.$router.push({
            name: 'goodArticle'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.share-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px;
      border-radius: 2px;

      .title {
        word(20px, #404157);
        font-weight: 550;
      }

      .configure-form {
        margin: 50px 80px 0;

        .input {
          width: 150px;
        }
      }

      .add-goods-box{
        height: 40px;
        box-sizing: border-box;
        flex-x();
        border: 1px solid #E8E8E8;
        padding: 0 12px;
        border-radius: 4px;
        .left{
          // width: 600px;
          // min-height: 120px;
          // border-radius: 5px;
          // border: 1px solid #E8E8E8;
          // padding: 6px 10px;
          box-sizing: border-box;
          flex-x(flex-start, flex-start);
          .item{
            height: 24px;
            min-width: 60px;
            padding:0 12px;
            border-radius: 2px;
            background: #EBEBEB;
            word(12px, #333);
            flex-x(center);
            margin-right: 8px;
            // margin-bottom: 8px;
            position: relative;
            div{
              line-height: 16px;
              position: absolute;
              right: -6px;
              top: -6px;
              cursor: pointer;
            }
          }
        }
        .btn{
          word(14px, #5283FF);
          cursor: pointer;
        }
      }

      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .tip {
        word(15, #EA0000);
        margin-top: 24px;
        margin-left: 80px;
      }

      .btn-box {
        .btn {
          confirm-btn();
          width: 145px;
          height: 32px;
          margin-top: 24px;
          margin-left: 190px;
        }
      }

      .addImg {
        .tips {
          // margin-bottom: 12px;
          line-height: 40px;
        }

        .icon {
          width: 208px;
          height: 130px;
        }

        .img {
          width: 208px;
          height: auto;
        }

        p {
          margin: 0;
        }

        .tip {
          color: gray9;
        }
      }
    }
  }
  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
  .add-goods-dialog{
    .search-box{
      flex-x(center);
      .input{
        margin-left: 20px;
        margin-right: 5px;
      }
      .btn{
        width: 72px;
        height: 32px;
        border-radius: 5px;
        background: #5283FF;
        cursor: pointer;
        flex-x(center);
        word(14px, #fff);
      }
    }
    .tip{
      flex-x(center);
      margin: 15px 0;
      word(14px, #E33B3B);
    }
    .table-btn {
      width: 65px;
      height: 24px;
      line-height: 24px;
      color: gray3;
      font-size: 12px;
      margin-right: 8px;
      cancel-btn();
    }
  }
  .brand-pic{
    width: 32px;
    height: 32px;
    border-radius: 5px;
  }
}
</style>
